module.exports = __webpack_public_path__ + "static/media/DTD-2026.ed6aebcf.png";